import { Component } from 'react';
import _ from 'lodash';
import PanelComponent from '../components/shared_components/PanelComponent';
import MaximumMortgageIframeComponent from '../components/calculation/maximum_mortgage/MaximumMortgageIframeComponent';

class MaximumMortageContainer extends Component {
  constructor(props) {
    super(props);

    this.setLocation = this.setLocation.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  setLocation(e) {
    window.location.href = e.target.href;
  }

  render() {
    return (
      <div className="calculation-container">
        <div className="row calculation-container__header">
          <h1>Hoeveel kunt u lenen?</h1>
          <h1>Bereken uw Maximale Hypotheek</h1>
        </div>

        <PanelComponent show classNames="calculation-container--calculation-form-panel row with-iframe">
          <MaximumMortgageIframeComponent />
        </PanelComponent>
      </div>
    );
  }
}

export default MaximumMortageContainer;
